import { toTitleCase } from "./utils";

// Static metadata map; extend as needed when backend adds new permissions.
export const PERMISSION_METADATA = {
  "role_permission:view": {
    label: "View",
    group: "Role Permissions",
    sub_group: "Role Permissions",
  },
  "role_permission:create": {
    label: "Create",
    group: "Role Permissions",
    sub_group: "Role Permissions",
  },
  "role_permission:edit": {
    label: "Edit",
    group: "Role Permissions",
    sub_group: "Role Permissions",
  },
  "role_permission:delete": {
    label: "Delete",
    group: "Role Permissions",
    sub_group: "Role Permissions",
  },
  "team_member:view": {
    label: "View",
    group: "Team Member",
    sub_group: "Team Member",
  },
  "team_member:create": {
    label: "Create",
    group: "Team Member",
    sub_group: "Team Member",
  },
  "team_member:edit": {
    label: "Edit",
    group: "Team Member",
    sub_group: "Team Member",
  },
  "team_member:delete": {
    label: "Delete",
    group: "Team Member",
    sub_group: "Team Member",
  },
  "dashboard:view": {
    label: "View",
    group: "Dashboard",
    sub_group: "Dashboard",
  },
  "dashboard:admin_view": {
    label: "View",
    group: "Dashboard",
    sub_group: "Dashboard",
  },
  "dashboard:marketing_view": {
    label: "View",
    group: "Dashboard",
    sub_group: "Dashboard",
  },
  "dashboard:sales_view": {
    label: "View",
    group: "Dashboard",
    sub_group: "Dashboard",
  },
  "dashboard:custom_view": {
    label: "View",
    group: "Dashboard",
    sub_group: "Dashboard",
  },
  "dashboard:custom_create": {
    label: "Create",
    group: "Dashboard",
    sub_group: "Dashboard",
  },
  "dashboard:custom_edit": {
    label: "Edit",
    group: "Dashboard",
    sub_group: "Dashboard",
  },
  "dashboard:custom_delete": {
    label: "Delete",
    group: "Dashboard",
    sub_group: "Dashboard",
  },
  "whatsapp:access": {
    label: "Access",
    group: "WhatsApp",
    sub_group: "WhatsApp",
  },
  "chatbot:access": {
    label: "Access",
    group: "Chatbot",
    sub_group: "Chatbot",
  },
  "chatbot:view": {
    label: "View",
    group: "Chatbot",
    sub_group: "Chatbot",
  },
  "chatbot:create": {
    label: "Create",
    group: "Chatbot",
    sub_group: "Chatbot",
  },
  "chatbot:edit": {
    label: "Edit",
    group: "Chatbot",
    sub_group: "Chatbot",
  },
  "chatbot:delete": {
    label: "Delete",
    group: "Chatbot",
    sub_group: "Chatbot",
  },
  "contacts:view": {
    label: "View",
    group: "Contacts",
    sub_group: "Contacts",
  },
  "contacts:create": {
    label: "Create",
    group: "Contacts",
    sub_group: "Contacts",
  },
  "contacts:edit": {
    label: "Edit",
    group: "Contacts",
    sub_group: "Contacts",
  },
  "contacts:delete": {
    label: "Delete",
    group: "Contacts",
    sub_group: "Contacts",
  },
  "contact:bulk_delete": {
    label: "Bulk Delete",
    group: "Contacts",
    sub_group: "Contacts",
  },
  "contact:import": {
    label: "Import",
    group: "Contacts",
    sub_group: "Contacts",
  },
  "contact:export": {
    label: "Export",
    group: "Contacts",
    sub_group: "Contacts",
  },
  "contact:add_custom_field": {
    label: "Add Custom Field",
    group: "Contacts",
    sub_group: "Contacts",
  },
  "company:view": {
    label: "View",
    group: "Company",
    sub_group: "Company",
  },
  "company:create": {
    label: "Create",
    group: "Company",
    sub_group: "Company",
  },
  "company:edit": {
    label: "Edit",
    group: "Company",
    sub_group: "Company",
  },
  "company:delete": {
    label: "Delete",
    group: "Company",
    sub_group: "Company",
  },
  "company:add_custom_field": {
    label: "Add Custom Field",
    group: "Company",
    sub_group: "Company",
  },
  "pipeline:view": {
    label: "View",
    group: "Pipeline",
    sub_group: "Pipeline",
  },
  "pipeline:create": {
    label: "Create",
    group: "Pipeline",
    sub_group: "Pipeline",
  },
  "pipeline:edit": {
    label: "Edit",
    group: "Pipeline",
    sub_group: "Pipeline",
  },
  "pipeline:delete": {
    label: "Delete",
    group: "Pipeline",
    sub_group: "Pipeline",
  },
  "deal:view": {
    label: "View",
    group: "Deals",
    sub_group: "Deals",
  },
  "deal:create": {
    label: "Create",
    group: "Deals",
    sub_group: "Deals",
  },
  "deal:edit": {
    label: "Edit",
    group: "Deals",
    sub_group: "Deals",
  },
  "deal:delete": {
    label: "Delete",
    group: "Deals",
    sub_group: "Deals",
  },
  "deal:add_custom_field": {
    label: "Add Custom Field",
    group: "Deals",
    sub_group: "Deals",
  },
  "bookings:view": {
    label: "View",
    group: "Bookings",
    sub_group: "Bookings",
  },
  "booking:edit": {
    label: "Edit",
    group: "Bookings",
    sub_group: "Bookings",
  },
  "engagement:view": {
    label: "View",
    group: "Engagement",
    sub_group: "Engagement",
  },
  "project:view": {
    label: "View",
    group: "Project",
    sub_group: "Project",
  },
  "project:create": {
    label: "Create",
    group: "Project",
    sub_group: "Project",
  },
  "project:edit": {
    label: "Edit",
    group: "Project",
    sub_group: "Project",
  },
  "project:delete": {
    label: "Delete",
    group: "Project",
    sub_group: "Project",
  },
  "project:add_custom_field": {
    label: "Add Custom Field",
    group: "Project",
    sub_group: "Project",
  },
  "estimate:view": {
    label: "View",
    group: "Estimate",
    sub_group: "Estimate",
  },
  "estimate:create": {
    label: "Create",
    group: "Estimate",
    sub_group: "Estimate",
  },
  "estimate:edit": {
    label: "Edit",
    group: "Estimate",
    sub_group: "Estimate",
  },
  "estimate:delete": {
    label: "Delete",
    group: "Estimate",
    sub_group: "Estimate",
  },
  "estimate:add_custom_field": {
    label: "Add Custom Field",
    group: "Estimate",
    sub_group: "Estimate",
  },
  "project_template:view": {
    label: "View",
    group: "Project Template",
    sub_group: "Project Template",
  },
  "project_template:create": {
    label: "Create",
    group: "Project Template",
    sub_group: "Project Template",
  },
  "project_template:edit": {
    label: "Edit",
    group: "Project Template",
    sub_group: "Project Template",
  },
  "project_template:delete": {
    label: "Delete",
    group: "Project Template",
    sub_group: "Project Template",
  },
  "project_invoice:view": {
    label: "View",
    group: "Project Invoice",
    sub_group: "Project Invoice",
  },
  "project_invoice:create": {
    label: "Create",
    group: "Project Invoice",
    sub_group: "Project Invoice",
  },
  "project_invoice:edit": {
    label: "Edit",
    group: "Project Invoice",
    sub_group: "Project Invoice",
  },
  "project_invoice:delete": {
    label: "Delete",
    group: "Project Invoice",
    sub_group: "Project Invoice",
  },
  "offering:view": {
    label: "View",
    group: "Offering",
    sub_group: "Offering",
  },
  "offering:create": {
    label: "Create",
    group: "Offering",
    sub_group: "Offering",
  },
  "offering:edit": {
    label: "Edit",
    group: "Offering",
    sub_group: "Offering",
  },
  "offering:delete": {
    label: "Delete",
    group: "Offering",
    sub_group: "Offering",
  },
  "product:add_custom_field": {
    label: "Add Custom Field",
    group: "Product",
    sub_group: "Product",
  },
  "agreement:view": {
    label: "View",
    group: "Agreement",
    sub_group: "Agreement",
  },
  "agreement:create": {
    label: "Create",
    group: "Agreement",
    sub_group: "Agreement",
  },
  "agreement:edit": {
    label: "Edit",
    group: "Agreement",
    sub_group: "Agreement",
  },
  "agreement:delete": {
    label: "Delete",
    group: "Agreement",
    sub_group: "Agreement",
  },
  "coupon:view": {
    label: "View",
    group: "Coupon",
    sub_group: "Coupon",
  },
  "coupon:create": {
    label: "Create",
    group: "Coupon",
    sub_group: "Coupon",
  },
  "coupon:edit": {
    label: "Edit",
    group: "Coupon",
    sub_group: "Coupon",
  },
  "coupon:delete": {
    label: "Delete",
    group: "Coupon",
    sub_group: "Coupon",
  },
  "campaign:view": {
    label: "View Campaign",
    group: "Campaign",
    sub_group: "Campaign",
  },
  "campaign:create": {
    label: "Create Campaign",
    group: "Campaign",
    sub_group: "Campaign",
  },
  "campaign:edit": {
    label: "Edit Campaign",
    group: "Campaign",
    sub_group: "Campaign",
  },
  "campaign:delete": {
    label: "Delete Campaign",
    group: "Campaign",
    sub_group: "Campaign",
  },
  "landing_page:view": {
    label: "View",
    group: "Landing Page",
    sub_group: "Landing Page",
  },
  "landing_page:create": {
    label: "Create",
    group: "Landing Page",
    sub_group: "Landing Page",
  },
  "landing_page:edit": {
    label: "Edit",
    group: "Landing Page",
    sub_group: "Landing Page",
  },
  "landing_page:delete": {
    label: "Delete",
    group: "Landing Page",
    sub_group: "Landing Page",
  },
  "form:view": {
    label: "View",
    group: "Form",
    sub_group: "Form",
  },
  "form:create": {
    label: "Create",
    group: "Form",
    sub_group: "Form",
  },
  "form:edit": {
    label: "Edit",
    group: "Form",
    sub_group: "Form",
  },
  "form:delete": {
    label: "Delete",
    group: "Form",
    sub_group: "Form",
  },
  "social:view": {
    label: "Monitor Accounts",
    group: "Social",
    sub_group: "Social",
  },
  "social:create": {
    label: "Schedule Posts",
    group: "Social",
    sub_group: "Social",
  },
  "social:add": {
    label: "Add Account",
    group: "Social",
    sub_group: "Social",
  },
  "account_billing:access": {
    label: "Account and Billing Access",
    group: "Account Billing",
    sub_group: "Account Billing",
  },
  "api:access": {
    label: "API Access",
    group: "API",
    sub_group: "API",
  },
  "business_flow:access": {
    label: "Business Flow",
    group: "Business Flow",
    sub_group: "Business Flow",
  },
  "calling_sms:access": {
    label: "Calling & SMS Setup Access",
    group: "Calling SMS",
    sub_group: "Calling SMS",
  },
  "company_setting:access": {
    label: "Company Settings Access",
    group: "Company Setting",
    sub_group: "Company Setting",
  },
  "credit:access": {
    label: "Credits Access",
    group: "Credit",
    sub_group: "Credit",
  },
  "document:view": {
    label: "View",
    group: "Document",
    sub_group: "Document",
  },
  "document:create": {
    label: "Create",
    group: "Document",
    sub_group: "Document",
  },
  "document:edit": {
    label: "Edit",
    group: "Document",
    sub_group: "Document",
  },
  "document:delete": {
    label: "Delete",
    group: "Document",
    sub_group: "Document",
  },
  "email_configuration:edit": {
    label: "Access to Update Linked Campaign Email",
    group: "Email Configuration",
    sub_group: "Email Configuration",
  },
  "email:view": {
    label: "View",
    group: "Email",
    sub_group: "Email",
  },
  "email:create": {
    label: "Create",
    group: "Email",
    sub_group: "Email",
  },
  "email:edit": {
    label: "Edit",
    group: "Email",
    sub_group: "Email",
  },
  "email:delete": {
    label: "Delete",
    group: "Email",
    sub_group: "Email",
  },
  "integration:access": {
    label: "Integrations Access",
    group: "Integration",
    sub_group: "Integration",
  },
  "payment_gateway:access": {
    label: "Payment Gateway Access",
    group: "Payment Gateway",
    sub_group: "Payment Gateway",
  },
  "scoring_rule:view": {
    label: "View",
    group: "Scoring Rule",
    sub_group: "Scoring Rule",
  },
  "scoring_rule:create": {
    label: "Create",
    group: "Scoring Rule",
    sub_group: "Scoring Rule",
  },
  "scoring_rule:edit": {
    label: "Edit",
    group: "Scoring Rule",
    sub_group: "Scoring Rule",
  },
  "scoring_rule:delete": {
    label: "Delete",
    group: "Scoring Rule",
    sub_group: "Scoring Rule",
  },
  "scoring_rule:update_score_meter_range": {
    label: "Update Score Meter Range",
    group: "Scoring Rule",
    sub_group: "Scoring Rule",
  },
  "tag:view": {
    label: "View",
    group: "Tag",
    sub_group: "Tag",
  },
  "tag:create": {
    label: "Create",
    group: "Tag",
    sub_group: "Tag",
  },
  "tag:update": {
    label: "Edit",
    group: "Tag",
    sub_group: "Tag",
  },
  "tag:delete": {
    label: "Delete",
    group: "Tag",
    sub_group: "Tag",
  },
  "team_member:update": {
    label: "Edit",
    group: "Team Member",
    sub_group: "Team Member",
  },
  "tracking_script:access": {
    label: "Tracking Script Access",
    group: "Tracking Script",
    sub_group: "Tracking Script",
  },
  "source:view": {
    label: "Sources View",
    group: "Source",
    sub_group: "Source",
  },
  "source:create": {
    label: "Sources Create",
    group: "Source",
    sub_group: "Source",
  },
  "source:edit": {
    label: "Sources Edit",
    group: "Source",
    sub_group: "Source",
  },
  "source:delete": {
    label: "Sources Delete",
    group: "Source",
    sub_group: "Source",
  },
  "filter:view": {
    label: "Filters View",
    group: "Filter",
    sub_group: "Filter",
  },
  "filter:delete": {
    label: "Filters Delete",
    group: "Filter",
    sub_group: "Filter",
  },
  "whatsapp_setup:view": {
    label: "WhatsApp Setup",
    group: "WhatsApp Setup",
    sub_group: "WhatsApp Setup",
  },
  "whatsapp:view": {
    label: "View",
    group: "WhatsApp",
    sub_group: "WhatsApp",
  },
  "whatsapp:create": {
    label: "Create",
    group: "WhatsApp",
    sub_group: "WhatsApp",
  },
  "whatsapp:edit": {
    label: "Edit",
    group: "WhatsApp",
    sub_group: "WhatsApp",
  },
  "whatsapp:delete": {
    label: "Delete",
    group: "WhatsApp",
    sub_group: "WhatsApp",
  },
  "tax:view": {
    label: "View",
    group: "Tax",
    sub_group: "Tax",
  },
  "tax:create": {
    label: "Create",
    group: "Tax",
    sub_group: "Tax",
  },
  "tax:update": {
    label: "Edit",
    group: "Tax",
    sub_group: "Tax",
  },
  "tax:delete": {
    label: "Delete",
    group: "Tax",
    sub_group: "Tax",
  },
  "plan:view": {
    label: "View",
    group: "Plan",
    sub_group: "Plan",
  },
  "plan:create": {
    label: "Create",
    group: "Plan",
    sub_group: "Plan",
  },
  "plan:edit": {
    label: "Edit",
    group: "Plan",
    sub_group: "Plan",
  },
  "plan:delete": {
    label: "Delete",
    group: "Plan",
    sub_group: "Plan",
  },
  "layout:view": {
    label: "View",
    group: "Layout",
    sub_group: "Layout",
  },
  "layout:create": {
    label: "Create",
    group: "Layout",
    sub_group: "Layout",
  },
  "layout:edit": {
    label: "Edit",
    group: "Layout",
    sub_group: "Layout",
  },
  "layout:delete": {
    label: "Delete",
    group: "Layout",
    sub_group: "Layout",
  },
  "subscription:view": {
    label: "View",
    group: "Subscription",
    sub_group: "Subscription",
  },
  "subscription:edit": {
    label: "Edit",
    group: "Subscription",
    sub_group: "Subscription",
  },
};

const reportedMissing = new Set();

const deriveMetadata = (name) => {
  if (!name) {
    return { label: "Permission", group: "General", sub_group: "General" };
  }
  const [module, action] = name.split(":");
  const baseLabel = action || module || "Permission";
  const label = toTitleCase(baseLabel.replace(/_/g, " "));
  const groupLabel = toTitleCase((module || "General").replace(/_/g, " "));
  return {
    label,
    group: groupLabel,
    sub_group: groupLabel,
  };
};

export const resolvePermissionMetadata = (name) => {
  if (!name) return deriveMetadata(name);
  const meta = PERMISSION_METADATA[name];
  if (!meta && !reportedMissing.has(name)) {
    reportedMissing.add(name);
    console.warn(`[Permissions] Missing metadata for permission "${name}"`);
  }
  return meta || deriveMetadata(name);
};

export const normalizePermission = (permission) => {
  if (!permission || typeof permission !== "object") return null;
  const name = permission.name || "";
  const meta = resolvePermissionMetadata(name);
  const accessType =
    permission.access_type ||
    permission?.pivot?.access_type ||
    permission?.pivot?.specialAccessType ||
    "all";
  return {
    ...permission,
    label: permission.label || meta.label,
    group: permission.group || meta.group,
    sub_group: permission.sub_group || meta.sub_group,
    access_type: accessType,
  };
};

export const normalizePermissionList = (permissions = []) =>
  permissions
    .map((perm) => normalizePermission(perm))
    .filter((perm) => perm !== null);
